import { render, staticRenderFns } from "./ActividadesGrid.vue?vue&type=template&id=025d167a&"
import script from "./ActividadesGrid.vue?vue&type=script&lang=ts&"
export * from "./ActividadesGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports